/* global axios */

import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  analyticsMetrics(id) {
    return axios.get(`${this.url}/${id}/analytics/metrics`);
  }

  analyticsContacts(id, { status, page } = {}) {
    return axios.get(`${this.url}/${id}/analytics/contacts`, {
      params: { status, page },
    });
  }

  // OMANREAL PATCH 15 -- CSV export rides the contacts endpoint so it inherits its
  // authorization; export=csv switches the response and drops pagination.
  analyticsExport(id, { status, timezoneOffset } = {}) {
    return axios.get(`${this.url}/${id}/analytics/contacts`, {
      params: { status, export: 'csv', timezone_offset: timezoneOffset },
    });
  }
}

export default new CampaignsAPI();
